import { Injectable, EventEmitter } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LocalstorageService {
  navchange: EventEmitter<number> = new EventEmitter();
  constructor() { }

  private subject = new Subject<any>();
  private subjectLogin = new Subject<any>();
  private subjectToken = new Subject<any>();

  emitNavChangeEvent(number) {
    this.navchange.emit(number);
  }
  getNavChangeEmitter() {
    return this.navchange;
  }

  sendMessage(message: string) {
    this.subject.next({ text: message });
  }

  clearMessage() {
    this.subject.next();
  }

  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }



  sendLoginUser(message: string) {
    this.subjectLogin.next({ text: message });
  }

  getLoginUser(): Observable<any> {
    return this.subjectLogin.asObservable();
  }

  sendToken(message: string) {
    this.subjectToken.next({ text: message });
  }

  getToken(): Observable<any> {
    return this.subjectToken.asObservable();
  }


}
